import { cn } from '@finn/ui-utils';
import { Fragment } from 'react';

import { useDiscoveryConfig } from '../../core/data/MetadataProvider';
import { GenericVehicleDetails } from '../../core/types';
import { extractVehicleAttributes } from '../helpers/extractVehicleAttributes';

export const AttributesRow = ({
  vehicle,
}: {
  vehicle: GenericVehicleDetails;
}) => {
  const config = useDiscoveryConfig();

  // if is variant 2 we want to remove gearshift
  const subscriptionAttributes = config?.subscriptionAttributes || [
    { key: 'trim_name' },
    { key: 'fuel' },
  ];

  const colorCount = vehicle.color_list?.filter(
    (color) => color.availability || vehicle?.coming_soon
  ).length;

  const attributes = extractVehicleAttributes(vehicle, subscriptionAttributes);
  const shouldRenderColors = colorCount > 1;

  return (
    <div
      className={cn('relative flex items-center truncate', {
        'inline-block whitespace-normal': config?.subscriptionAttributes,
      })}
    >
      {attributes.map((attribute, idx) => (
        <Fragment key={attribute?.key}>
          <span className="inline-block whitespace-nowrap py-1 body-12-light sm:body-14-light">
            {String(attribute?.text)}
          </span>
          {idx < attributes.length - 1 || shouldRenderColors ? (
            <div
              className={cn(
                'mx-1 my-0.5 inline-block size-1 min-h-1 min-w-1 rounded bg-pearl py-0.5 md:mx-2',
                shouldRenderColors ? '' : 'group-last:hidden'
              )}
            />
          ) : null}
        </Fragment>
      ))}

      {shouldRenderColors && (
        <span
          className={cn('inline-block py-0.5 body-12-light sm:body-14-light')}
        >
          {colorCount > 1 ? colorCount : ''} {'Farben'}
        </span>
      )}
    </div>
  );
};
